<template>
  <svg v-if="isFill" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <g fill="#EE4D2D">
      <path :d="bagPath" />
      <path :d="handlePath" />
    </g>
    <path :d="smilePath" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path :d="bagPath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
    <path :d="handlePath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
    <path :d="smilePath" :stroke="color" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script>
// Original simplified shopping-bag glyph (not the official trademark) — replace with the official logo after brand-guideline review.
const CONST_BAG_PATH = 'M8 13h20l2 17a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z';
const CONST_HANDLE_PATH = 'M12 14v-3a6 6 0 0 1 12 0v3h-2.5v-3a3.5 3.5 0 0 0-7 0v3z';
const CONST_SMILE_PATH = 'M13 21c1.5 3 8.5 3 10 0';

export default {
  name: 'ShopeeIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    isFill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bagPath() {
      return CONST_BAG_PATH;
    },
    handlePath() {
      return CONST_HANDLE_PATH;
    },
    smilePath() {
      return CONST_SMILE_PATH;
    },
  },
};
</script>
